import { formatJsonDataset as fjd } from "../../components/renderers";

export const financeconfig = {

  chartofaccounts: {
    service: {
      name: 'chartofaccounts',
      title: 'Chart of Accounts',
      num: false,
      fields: [
        'rid', 'nam', 'shc', 'ati', 'atn', 'afi', 'abi', 'afn', 'abn', 'ann', 'ani', 'cfi', 'cfn', 'atc', 'aci', 'acn', 'acc', 'dsc', 'exi', 'sts', 'ast', 'stp'
      ],
      grid: [
        ['nam', 'Name'],
        ['shc', 'Code'],
        ['atn', 'Type'],
        ['acn', 'Category'],
        ['abc', 'Budget Class'],
        ['afc', 'Function'],
        ['anc', 'Nature'],
        ['cfc', 'Cashflow'],
        ['dsc', 'Description'],
        ['exi', 'Extra Info'],
        ['stp', 'Stamp']
      ],
      menu: {
        mnu: [
          { t: 'Name', v: 'nam' },
          { t: 'Code', v: 'shc' },
          { t: 'Category', v: 'acn' }
        ],
        def: 'nam'
      },
      eform: [
        // { id:'rid', label:'Record ID', type:'rf', req:0, ops:{} },
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 1, ops: {} },
        { id: 'ati', label: 'Type', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'accounttype' } },
        { id: 'aci', label: 'Category', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'accountcat' } },
        { id: 'abi', label: 'Budget Account Class', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'accountbudgetclass' } },
        { id: 'afi', label: 'Account Purpose/Function', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'accountfunction' } },
        { id: 'cfi', label: 'Cashflow', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'accountcashflow' } },
        { id: 'ani', label: 'Account Nature', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'accountnature' } },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
        { id: 'sts', label: 'Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
      ]
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
    formatters: { grid: { exi: fjd } }
  },

  costcenter: {
    service: {
      name: 'costcenter',
      title: 'Cost Centers',
      num: false,
      fields: [
        'rid', 'nam', 'shc', 'uni', 'unn', 'unc', 'mgi', 'mgn', 'mgc', 'dsc', 'exi', 'sts', 'ast', 'stp'
      ],
      grid: [
        ['nam', 'Name'],
        ['shc', 'Code'],
        ['unn', 'Unit'],
        ['mgn', 'Manager'],
        ['dsc', 'Description'],
        ['exi', 'Extra Info'],
        ['stp', 'Stamp']
      ],
      menu: {
        mnu: [
          { t: 'Name', v: 'nam' },
          { t: 'Code', v: 'shc' },
          { t: 'Unit', v: 'unn' }
        ],
        def: 'nam'
      },
      eform: [
        // { id:'rid', label:'Record ID', type:'rf', req:0, ops:{} },
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 1, ops: {} },
        { id: 'uni', label: 'Unit', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'orgunit' } },
        { id: 'mgi', label: 'Manager', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'staff' } },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
        { id: 'sts', label: 'Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
      ]
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
    formatters: { grid: { exi: fjd } }
  },

};